
export const ArchPorto = () => {
    return (
        <>
            <section className="flex justify-center bg-gradient-to-b from-[#FFFFFF] to-[#ebf3f3] px-[16px] md:px-[32px] lg:px-[160px] pt-[3rem] md:pt-[5rem] font-jakarta ">
                <div
                    key="index"
                    className="flex flex-col md:flex-row w-full items-center border-t border-[#D1D8D7] pt-[3rem] pb-[3.5rem] md:pt-[5rem] md:pb-[7rem]"
                // border-t border-[#dfe4e3] 
                >
                    <section className="w-full font-jakarta flex flex-col gap-[1rem] md:gap-[1.25rem] ">
                        <h1 className="hidden md:block text-[#002921] text-[28px] leading-snug font-semibold transition-colors" >
                            Architecture & <br />
                            Graphic Design  <br />
                            Portfolio (2023)
                        </h1>
                        <h1 className="md:hidden text-[#002921] text-[22px] leading-snug font-semibold transition-colors" >
                            Architecture & Graphic Design Portfolio (2023)
                        </h1>
                        <p className="text-[#002921] font-medium max-w-[25rem] px-[0.25rem] md:px-0 text-[17px] md:text-[18px] opacity-[0.6]">
                            by Thoby ZA
                        </p>
                        <div className="flex gap-[1rem] relative mt-[0.5rem] md:mt-[1rem]">
                            <a
                                href="https://issuu.com/thoby.athaya/docs/portfolio_2_thobyza_2023_comp"
                                target="_blank"
                                rel="noopener noreferrer"
                                id="button-animation"
                                className="flex items-center group gap-[0.6rem] w-max rounded-full border border-gray-400 text-[1rem] text-[#828997] py-[0.6rem] px-[1rem]"
                            >
                                <span className="font-medium">View Portfolio</span>
                                <svg
                                    viewBox="0 0 26 26"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                    className="h-[1.1rem] w-[1.1rem] mt-[2px] stroke-[#828997] group-hover:stroke-[#002921]"
                                >
                                    <path
                                        d="M10.3291 5.68945H20.6694C20.727 5.68945 20.7738 5.73622 20.7738 5.7939V16.1342"
                                        stroke-width="2.08894"
                                        stroke-miterlimit="10"
                                    ></path>
                                    <path
                                        d="M20.7744 5.68945L7.19629 19.2676"
                                        stroke-width="2.08894"
                                        stroke-miterlimit="10"
                                    ></path>
                                </svg>
                            </a>
                            {/*  */}
                        </div>
                    </section>
                    <section className="w-full h-[17.5rem] md:h-[22rem] mt-[2rem] md:mt-0">
                        <img
                            src="/assets/others/porto-2023.webp"
                            loading="lazy"
                            alt=""
                            className="h-full w-full rounded-2xl object-cover opacity-[0.8]"
                        />
                    </section>
                </div>
            </section>
        </>
    )
}